import MaterialTable from '@material-ui/core/Table'
import MaterialTableBody from '@material-ui/core/TableBody'
import MaterialTableCell from '@material-ui/core/TableCell'
import MaterialTableHead from '@material-ui/core/TableHead'
import MaterialTableRow from '@material-ui/core/TableRow'
import MaterialTableContainer from '@material-ui/core/TableContainer'
import styled from 'styled-components'
import colors from '../../tokens/colors'
import fonts from '../../tokens/fonts'

export const Table = styled(MaterialTable)`
  tr:nth-child(even) {
    background-color: ${colors.neutralColorHighPure};
  }

  td {
    &.MuiTableCell-root {
      border: 0;
      color: ${colors.neutralColorLowPure};
      font-size: 1.4rem;
      padding-bottom: 0.7rem;
      padding-top: 0.7rem;
    }
  }

  .MuiTableCell-root {
    border-color: transparent;
    color: ${colors.neutralColorLowPure};
    font-family: ${fonts.inter};
    font-size: 1.2rem;
    font-style: normal;
    font-weight: normal;
    line-height: 1.5rem;
  }

  .MuiTableCell-head {
    background-color: ${colors.neutralColorHighPure};
    text-transform: uppercase;
  }
`

export const TableBody = styled(MaterialTableBody)``

export const TableCell = styled(MaterialTableCell)``

export const TableContainer = styled(MaterialTableContainer)`
  background-color: ${colors.neutralColorHighLight};
`

export const TableHead = styled(MaterialTableHead)``

export const TableRow = styled(MaterialTableRow)``
